import React from 'react';
import './sec1_main_home.css'
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import { useState } from 'react';
import Header2 from '../component/common/title';
import pic15 from '../assets/pic15.png';
import pic16 from '../assets/pic16.png';
import pic17 from '../assets/pic17.png';
import pic18 from '../assets/pic18.png';
import pic19 from '../assets/pic19.png';
import pic20 from '../assets/pic20.png';
import pic21 from '../assets/pic21.png';
import pic22 from '../assets/pic22.png';
import pic23 from '../assets/pic23.png';
import { supabase } from '../supabase';
import { useEffect } from 'react';


const Sec1home = () => {
     const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const [recentBookings, setRecentBookings] = useState([]);

const [totalEvents, setTotalEvents] = useState(0);
const [totalBookings, setTotalBookings] = useState(0);
const [totalUsers, setTotalUsers] = useState(0);
const [averageRating, setAverageRating] = useState(0);

    const cardsData = [
    {
        id: 1,
        img1: pic15,
        img2: pic16,
        number: totalEvents,
        title: "Total Events",

    },
    {
        id: 2,
        img1: pic17,
        img2: pic18,
        number: totalBookings,
        title: "Total Bookings",

    },
        {
        id: 3,
        img1: pic19,
        img2: pic20,
        number: totalUsers,
        title: "Total Users",

    },
    {
        id: 4,
        img1: pic21,
        img2: pic22,
        number: averageRating,
        title: "Average Rating",

    }
    ];





useEffect(() => {
  const fetchRecentBookings = async () => {
    const { data, error } = await supabase
      .from('Booking')
      .select(`
          id,
        booking_date,
        Users:user_id (user_name),
        Events:Event_id (Event_title)
      `)
      .order('booking_date', { ascending: false })
      .limit(3);

    if (error) {
      console.log(error);
    } else {
      setRecentBookings(data);
    }
  };

  fetchRecentBookings();



 const fetchDashboardStats = async () => {


    const { count: eventsCount } = await supabase
      .from('Events')
      .select('*', { count: 'exact', head: true });

    const { count: bookingsCount } = await supabase
      .from('Booking')
      .select('*', { count: 'exact', head: true });

    const { count: usersCount } = await supabase
      .from('Users')
      .select('*', { count: 'exact', head: true });




      
    const { data: feedbackData } = await supabase
      .from('Feeback')
      .select('Rating');
    const avg =
      feedbackData?.length > 0
        ? (
            feedbackData.reduce(
              (sum, item) => sum + Number(item.Rating || 0),
              0
            ) / feedbackData.length
          ).toFixed(1)
        : 0;

    setTotalEvents(eventsCount || 0);
    setTotalBookings(bookingsCount || 0);
    setTotalUsers(usersCount || 0);
    setAverageRating(avg);
  };

  fetchDashboardStats();



}, []);










    return ( 
        <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                    <section className='information-container'>
                        <article className='container-content'>
                           <Header2 
                            title="Dashboard Overview"  
                            para="Welcome back! Here's what's happening with your events today."
                            />
                        </article>


                        <section className='container-content-sec1'>
                                <article className='cards-container-sec1'>
                                         {cardsData.map((card) => (
                                            <article className='card-sec1' key={card.id}>
                                            <figure className='container-imgs-sec1'>
                                                <img src={card.img1} alt='icon' />
                                                <img src={card.img2} alt='chart' />
                                            </figure>
                                            <h1 className='number-cards-sec1'>{card.number}</h1>
                                            <h2 className='title-cards-sec1'>{card.title}</h2>
                                            <h3 className='smalltext-sec1'>{card.subtitle}</h3>
                                            </article>
                                        ))}
                                </article>

                                <article className='conatinercards2-sec1'>

                                        <article className='card2-sec1'>
                                            <h2 className='header-card3-sec1'>Bookings Overview</h2>
                                            <img className='chart-sec1' src={pic23} alt='chart'></img>
                                        </article>

                                        <article className='card3-sec1'>
                                            <h2 className='header-card4'>Recent Booking</h2>
  {recentBookings.map((item) => (
                                            <article className='container-recent-booking' key={item.id}>

                                                <article className='container-card4-sec1'>
                                                    <h2 className='subheader-card4'> {item.Events?.Event_title}</h2>
                                                    <article className='container-name-time_recent-booking'>
                                                        <h3 className='name-recent-booking'> {item.Users?.user_name}</h3>
                                                        <h3 className='time-recent-booking'> {new Date(item.booking_date).toLocaleString()}</h3>
                                                    </article>
                                                </article>
                                                {/* <article className='container-card4-sec1'>
                                                    <h2 className='subheader-card4'>Shakira Live in Egypt</h2>
                                                    <article className='container-name-time_recent-booking'>
                                                        <h3 className='name-recent-booking'>Ahmed Hassan</h3>
                                                        <h3 className='time-recent-booking'>5 min ago</h3>
                                                    </article>
                                                </article>
                                                 <article className='container-card4-sec1'>
                                                    <h2 className='subheader-card4'>Shakira Live in Egypt</h2>
                                                    <article className='container-name-time_recent-booking'>
                                                        <h3 className='name-recent-booking'>Ahmed Hassan</h3>
                                                        <h3 className='time-recent-booking'>5 min ago</h3>
                                                    </article>
                                                    
                                                </article>                                                */}


                                            </article>

     ))}                                         
                                        </article>

                                </article>



                        </section>







                    </section>

            </section>
        </section>

     );
}
 
export default Sec1home;